import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { root } from 'baobab-react/higher-order'
import renderReact from 'utils/renderReact'
import Mapper from 'routes/Mapper'
import storage from 'utils/storage'
import isDOMAvailable from 'utils/isDOMAvailable'
import { locales } from 'locales'

class RootComponent extends React.Component {
  constructor(props) {
    super(props)
    storage.set('serverProps', props)
  }

  render() {
    intl.init({
      currentLocale: this.props.locale,
      locales: {
        id: locales('id'),
        en: locales('en'),
      },
      commonLocaleDataUrls: {
        id: 'https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/id.js',
        en: 'https://g.alicdn.com/react-intl-universal/locale-data/1.0.0/en.js',
      },
    })


    if (isDOMAvailable) {
      const params = new URLSearchParams(window.location.search.substring(1))

      const downloadCallback = params.get('download_callback')
      if (downloadCallback) window.location = downloadCallback

      const openTabCallback = params.get('open_tab_callback')
      if (openTabCallback) {
        Object.assign(document.createElement('a'), { target: '_blank', href: openTabCallback }).click()
      }

      window.history.pushState(null, '', window.location.pathname)
    }

    return (
      <Mapper />
    )
  }
}

RootComponent.propTypes = {
  locale: PropTypes.string,
}

RootComponent.defaultProps = {
  locale: 'id',
}

const SiteRoot = root(storage, RootComponent)

renderReact('SiteRoot', SiteRoot)
export default SiteRoot
